var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import ValuationTable from '@backoffice/components/claim/valuation/ValuationTable.vue';
const claim = namespace('claim');
let ChiffrageIdChiffrage = class ChiffrageIdChiffrage extends Vue {
    get selfRepairDiscouraged() {
        var _a, _b, _c, _d;
        return (_d = (_c = (_b = (_a = this.info) === null || _a === void 0 ? void 0 : _a.valuationTables) === null || _b === void 0 ? void 0 : _b.selfRepair) === null || _c === void 0 ? void 0 : _c.selfRepairDiscouraged) !== null && _d !== void 0 ? _d : false;
    }
    get hasDamagesWithExclusionReason() {
        var _a;
        const table = this.selfRepairTable;
        return (!!table &&
            'damagesWithExclusionReason' in table &&
            ((_a = table.damagesWithExclusionReason) !== null && _a !== void 0 ? _a : false) === true);
    }
    get selfRepairTable() {
        var _a, _b, _c;
        return ((_c = (_b = (_a = this.info) === null || _a === void 0 ? void 0 : _a.valuationTables) === null || _b === void 0 ? void 0 : _b.selfRepair) !== null && _c !== void 0 ? _c : {});
    }
    get imageSelfRepairSrc() {
        return require(`@declaration/assets/images/compensation/selfRepair.svg`);
    }
    valuationAmount(tableType) {
        var _a, _b, _c, _d, _e, _f, _g;
        const table = (_b = (_a = this.info) === null || _a === void 0 ? void 0 : _a.valuationTables) === null || _b === void 0 ? void 0 : _b[tableType];
        const totalRows = (_g = (_f = (_e = (_d = (_c = table === null || table === void 0 ? void 0 : table.sections) === null || _c === void 0 ? void 0 : _c.totals) === null || _d === void 0 ? void 0 : _d.modes) === null || _e === void 0 ? void 0 : _e.default) === null || _f === void 0 ? void 0 : _f.rows) !== null && _g !== void 0 ? _g : [];
        const amountRow = totalRows.find((row) => row.type === 'footer');
        if (amountRow &&
            'cells' in amountRow &&
            Array.isArray(amountRow.cells) &&
            amountRow.cells.length > 0) {
            return amountRow.cells[amountRow.cells.length - 1].displayValue;
        }
        return '-- €';
    }
    get pecuniaryTable() {
        var _a, _b, _c;
        return (_c = (_b = (_a = this.info) === null || _a === void 0 ? void 0 : _a.valuationTables) === null || _b === void 0 ? void 0 : _b.pecuniary) !== null && _c !== void 0 ? _c : {};
    }
    get imagePecuniarySrc() {
        return require(`@declaration/assets/images/compensation/otherArtisan.svg`);
    }
};
__decorate([
    claim.State('info')
], ChiffrageIdChiffrage.prototype, "info", void 0);
ChiffrageIdChiffrage = __decorate([
    Component({
        components: {
            ValuationTable,
        },
        name: 'ChiffragesIndemnisation',
        middleware: ['hasAccess'],
        filters: {},
        async fetch() { },
    })
], ChiffrageIdChiffrage);
export default ChiffrageIdChiffrage;
